import { render, staticRenderFns } from "./CalculatorTab.vue?vue&type=template&id=3ba8cf55&scoped=true&"
import script from "./CalculatorTab.vue?vue&type=script&lang=js&"
export * from "./CalculatorTab.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorTab.vue?vue&type=style&index=0&id=3ba8cf55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8cf55",
  null
  
)

export default component.exports